import {getCurrency} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppSelector} from '../../../../hooks/runtime'
import {getOrderedTickets} from '../../../../selectors/placed-order'
import {getSeatingPlan} from '../../../../selectors/seating/plan'
import {TotalBreakdown} from '../total-breakdown/total-breakdown'
import {SeatTicket} from './seat-ticket'
import {Ticket} from './ticket'
import s from './tickets-summary.scss'

export const TicketsSummary = ({event}: {event: ExtendedEvent}) => {
  const currency = getCurrency(event)
  const seatingPlan = useAppSelector(getSeatingPlan)
  const tickets = useAppSelector(getOrderedTickets)

  const hasSeats = tickets.some(ticket => ticket.seats?.placeIds.length)

  return (
    <div className={s.container} data-hook={DH.TICKETS_SUMMARY}>
      {hasSeats
        ? tickets.map(ticket =>
            ticket.seats.placeIds.map((seatId, seatIndex) => (
              <SeatTicket
                key={seatId}
                seatId={seatId}
                seatIndex={seatIndex}
                seatingPlan={seatingPlan}
                ticket={ticket}
                currency={currency}
              />
            )),
          )
        : tickets.map(ticket => <Ticket key={ticket.id} ticket={ticket} />)}
      <TotalBreakdown />
    </div>
  )
}
